import React from 'react';

/**
 * Props que devem ser filtradas por serem específicas de ferramentas de debug
 */
const FILTERED_PROPS = [
  'data-lov-id',
  'data-lov-name', 
  'data-component-path',
  'data-component-line',
  'data-component-file',
  'data-component-name',
  'data-component-content',
  // Adicionar outras props de debug comuns
  'data-testid',
  'data-cy',
  'data-automation',
  'data-qa',
  // Props específicas do React DevTools
  'data-reactroot',
  'data-react-checksum'
];

/**
 * HOC que remove props de debug antes de passar para componentes Material-UI
 */
export const withCleanProps = (Component) => {
  const CleanPropsWrapper = React.forwardRef((props, ref) => {
    // Filtra as props inválidas
    const cleanProps = Object.keys(props).reduce((acc, key) => {
      if (!FILTERED_PROPS.includes(key)) {
        acc[key] = props[key];
      }
      return acc;
    }, {});

    return <Component {...cleanProps} ref={ref} />;
  });

  CleanPropsWrapper.displayName = `withCleanProps(${Component.displayName || Component.name})`;
  
  return CleanPropsWrapper;
};

/**
 * Componente que remove automaticamente props de debug dos children
 */
export const CleanPropsProvider = ({ children }) => {
  return React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      const cleanProps = Object.keys(child.props).reduce((acc, key) => {
        if (!FILTERED_PROPS.includes(key)) {
          acc[key] = child.props[key];
        }
        return acc;
      }, {});

      return React.cloneElement(child, cleanProps);
    }
    return child;
  });
};
